import React from 'react';
import styled from 'styled-components';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { H4, P2 } from '../../Atoms/Typo';
import { IconSMArrowLeft, IconSMArrowRight } from '../../Atoms/Icon';
import { Button } from '../../Atoms/Button';

const Component = styled.div`
  flex: 1;
  .voda_table_pagination {
    display: flex;
    justify-content: center;
    margin-top: 40px;

    .ant-pagination-item {
      height: 36px;
      width: 36px;
      margin: 0px;
      ${P2}

      border: none;
      border-radius: 4px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 36px;
        line-height: 1.2;
        color: ${(props) => props.theme.colors.grey600};
      }
    }
    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.colors.primary};
      color: white;
      a {
        color: white;
      }
    }

    .ant-pagination-next {
    }

    .ant-pagination-next,
    .ant-pagination-prev {
      margin: 0px;
      height: 36px;
      width: 36px;
      .voda_default_button {
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 7px;
          height: 11.3px;
          path {
            fill: ${(props) => props.theme.colors.grey900};
          }
        }
      }
    }

    .ant-pagination-next.ant-pagination-disabled,
    .ant-pagination-prev.ant-pagination-disabled {
      .voda_default_button {
        cursor: not-allowed;
        svg {
          path {
            fill: ${(props) => props.theme.colors.grey500};
          }
        }
      }
    }
  }

  .ant-table-cell {
    ${P2};
    padding: 16px 24px;
    color: ${(props) => props.theme.colors.grey800};
    border-bottom-color: #eeeeee;

    .accent {
      ${H4};
      font-size: 16px;
      color: ${(props) => props.theme.colors.grey800};
    }
  }

  .ant-table-thead {
    .ant-table-cell {
      color: ${(props) => props.theme.colors.grey500};
      background-color: ${(props) => props.theme.colors.grey100};
      border: none;
    }
  }
`;

export interface SimpleTableProps {
  columns?: ColumnsType<any>;
  dataSource?: any[];
  pageSize?: number;
}

const SimpleTable = ({ columns, dataSource, pageSize }: SimpleTableProps) => {
  const itemRender = (
    page: number,
    type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next',
    originalElement: React.ReactElement<
      HTMLElement,
      string | React.JSXElementConstructor<any>
    >
  ) => {
    if (type === 'prev') {
      return (
        <Button isBlock>
          <IconSMArrowLeft />
        </Button>
      );
    }
    if (type === 'next') {
      return (
        <Button isBlock>
          <IconSMArrowRight />
        </Button>
      );
    }
    return originalElement;
  };

  return (
    <Component>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={{
          className: 'voda_table_pagination',
          pageSize,
          itemRender,
        }}
      />
    </Component>
  );
};

export default SimpleTable;
